import React from 'react';
import { Typography, Container } from '@mui/material';
import ContactSalesForm from './ContactSalesForm';

const ContactSalesPage: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        align="center"
        sx={{ fontWeight: 600 }}
      >
        Get in touch
      </Typography>
      <Typography
        variant="subtitle1"
        gutterBottom
        align="center"
        color="text.secondary"
      >
        Fill out the form below and our sales team will get back to you shortly
      </Typography>
      <ContactSalesForm formSource="Contact Sales Page" />
    </Container>
  );
};

export default ContactSalesPage;
